exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#editor-page{display:flex;flex-direction:row;align-items:stretch;height:100%}", ""]);

